import React from 'react';
import { Box, keyframes } from '@mui/material';

const shimmerAnimation = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

interface ShimmerTextProps {
  text: string;
}

const ShimmerText: React.FC<ShimmerTextProps> = ({ text }) => (
  <Box
    component="span"
    sx={{
      alignSelf: 'center',
      fontSize: 14,
      fontWeight: 600,
      background: 'linear-gradient(90deg, #7D8699 0%, #E0E3E9 10.89%, #7D8699 19.03%)',
      backgroundSize: '200% auto',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      animation: `${shimmerAnimation} 3s linear infinite reverse`,
    }}>
    {text}
  </Box>
);

export default ShimmerText;
